[
    "“The only way to do great work is to love what you do.” – Steve Jobs",
    "“The only limit to our realization of tomorrow will be our doubts of today.” – Franklin D. Roosevelt",
    "“The best way to predict the future is to create it.” – Peter Drucker"
]